import xhr from '../tools/xhr.js';
import auth from '../tools/storage.js';

import tools from '../tools/tools.js';
import filmApplicationFConsider from './filmApplicationsForConsider.js';

// const btnExport =  document.querySelector('#filmAFConsider').querySelector('button[name=excelExport]');
// const aExport =  document.querySelector('#filmAFConsider').querySelector('a[name=excelExport]');


const menuBt = document.querySelector('#MenuExportExcel');

const exportBody = document.querySelector('#excelExportFIELD');
// excelExportFIELD

const exFilmsCard = document.querySelector('#viewExportExcel');
const exFilmsCardAllInputs = exFilmsCard.querySelectorAll('input[type="checkbox"]');
const exFilmsCardAlStatusData = exFilmsCard.querySelectorAll('input[name="dataSource"]');

const exFilmsCardAlTypeData = exFilmsCard.querySelectorAll('input[name="typeFilms"]');

let exFilmsCardAllInputFilms = exFilmsCard.querySelector('div[name=page_films]').querySelectorAll('input');
const exFilmsCardAllInputFilmCreators = exFilmsCard.querySelector('div[name=page_creators]').querySelectorAll('input');


let allAgreemetnLists = [];
// btnExport.addEventListener('click', function () {

//   exFilmsCardAlStatusData.forEach((element) => {
//     if(parseInt(element.value, 10) === parseInt(exFilmsCard.querySelector('b[name="header"]').value, 10))
//       element.checked = true;
//     else
//       element.checked = false;

//   });
//   $(exFilmsCard).modal('show');
// });

function getCurrentStatusSourceData () {
  let returnValue = 0;
  exFilmsCardAlStatusData.forEach((element) => {
    if(element.checked)
      returnValue =  parseInt(element.value, 10);
    
  });
  return returnValue;
}


function getCurrentTypeSourceData () {
  let returnValue = 0;
  exFilmsCardAlTypeData.forEach((element) => {
    if(element.checked)
      returnValue =  parseInt(element.value, 10);
    
  });
  return returnValue;
}


exFilmsCard.querySelector('button[name=selectOrDeselectAll]').addEventListener('click', function (bt) {
  // console.log(bt.target.innerHTML);
  let allinputValues = false;
  if(bt.target.innerHTML === 'Выделить все'){
    bt.target.innerHTML = 'Отменить все';
    allinputValues = true;
  } else {
    allinputValues = false;
    bt.target.innerHTML = 'Выделить все';
  }

  exFilmsCardAllInputs.forEach((element) => {
    // console.log(element.type);
    if(element.type === 'checkbox')
      element.checked = allinputValues;
  });
});


exFilmsCard.querySelector('button[name=generate]').addEventListener('click', function () {
  // makeExport();
  allFileds = '';
  exFilmsCardAllInputs.forEach((element) => {
    if(element.attributes.name.nodeValue && element.attributes.name.nodeValue.length >1 && element.checked)
      allFileds = `${allFileds} "${element.attributes.name.nodeValue}",`;
  });

  if(allFileds.length > 1){
    allFileds = allFileds.substring(0, allFileds.length - 1);
  

    limitStep = 0;
    xhr.request = {
            metod: 'POST',
            url: `festival/${auth.currentFestival}/exportExcel/`,
            data: `sort=abc&fields=[${allFileds}]&data=requestFilms&step=${limitStep}&FilmsRequestStatus=${getCurrentStatusSourceData()}&FilmsRequestType=${getCurrentTypeSourceData()}`,
            callbackSuccess: onSuccessLoadExportData
          };
  } else
    alert('Выберите хотя бы один столбец!');
  // buildHeader();
  // makeExport();
});

let limitStep = 0;
let allFileds = '';
let tableHTML = '';
let allCreators = [];
let tableHTMLCreator = '';

const onSuccessLoadExportData = (servarAnswer) => {
  // console.log(servarAnswer);

  allCreators =[];
  // document.querySelector(`#${loaderSpinnerId}`).remove();
  if (servarAnswer.status === 200) {
      buildHeader(servarAnswer.message);
      buildBody(servarAnswer.data);
      buildHeaderCreator(servarAnswer.message);
      if(allCreators)
        buildBodyCreator();
      makeExport();
    // loadData();
  }
};

function buildHeader(nameFest) {
  let htmlBody = `<table id="tab1">
                    <tr>
                      <td>Фестиваль:</td>
                      <td data-f-bold="true">${nameFest}</td>
                      <td>Дата:</td>
                      <td>${  new Date().toLocaleString()}</td>
                      <td>Плаформа:</td>
                      <td  data-hyperlink="https://festapp.ru/lk/">https://festapp.ru/lk/</td>
                    </tr>
                    <tr>
                      <td></td>
                    </tr>
                    <tr>`;
  exFilmsCardAllInputFilms.forEach((element) => {
    if(element.attributes.name.nodeValue && element.attributes.name.nodeValue.length  > 1 && element.checked)
      htmlBody += `<td data-f-bold="true">${translateField(element.attributes.name.nodeValue)}</td>`;
  });
  htmlBody += '</tr>';
  tableHTML = htmlBody;

}

function buildHeaderCreator(nameFest) {
  let htmlBody = `<table id="tab2">
                    <tr>
                      <td>Фестиваль:</td>
                      <td data-f-bold="true">${nameFest}</td>
                      <td>Дата:</td>
                      <td>${  new Date().toLocaleString()}</td>
                      <td>Плаформа:</td>
                      <td  data-hyperlink="https://festapp.ru/lk/">https://festapp.ru/lk/</td>
                    </tr>
                    <tr>
                      <td></td>
                    </tr>
                    <tr>`;
  exFilmsCardAllInputFilmCreators.forEach((element) => {
    if(element.attributes.name.nodeValue && element.attributes.name.nodeValue.length  > 1 && element.checked)
      htmlBody += `<td data-f-bold="true">${translateField(element.attributes.name.nodeValue)}</td>`;
  });
  htmlBody += '</tr>';
  tableHTMLCreator = htmlBody;

}

function searchPost(postID) {
  let postName = '';
  let allPosts = filmApplicationFConsider.getPosts();
  allPosts.forEach((element) => {
    if (parseInt(postID, 10) === parseInt(element.id, 10))
      postName = element.name;
    
  });
  return postName;
}
function stringAddValueOnKey(str, dct, key, needSpaceAfter){

  if(dct.hasOwnProperty(key) && dct[key]){
    str = `${str}${dct[key]}`;
    if(needSpaceAfter)
      str = `${str} `;
  }

  return str;

}
function buildBodyCreator() {
  let countRow = 0;
  let rowHTML = '';
  allCreators.forEach((element) => {
    ++countRow;

    rowHTML += '<tr>';
     exFilmsCardAllInputFilmCreators.forEach((elementInput) => {
        if(elementInput.attributes.name.nodeValue && elementInput.attributes.name.nodeValue.length  > 1 && elementInput.checked && element)
        {

          if ('creator_page_fio' === elementInput.attributes.name.nodeValue){ 
            let rowValue = '';
            rowValue = stringAddValueOnKey(rowValue, element, 'nameF', true);
            rowValue = stringAddValueOnKey(rowValue, element, 'nameI', true);
            rowValue = stringAddValueOnKey(rowValue, element, 'nameO', true);

            rowHTML += `<td>${rowValue}</td>`;
          } else if('creator_page_fio_ENG' === elementInput.attributes.name.nodeValue){
            rowHTML += `<td></td>`;
          } else if('creator_page_fio_ENG' === elementInput.attributes.name.nodeValue){
            rowHTML += `<td></td>`;
          } else if('creator_page_contact_phone' === elementInput.attributes.name.nodeValue)
              rowHTML += `<td>${stringAddValueOnKey('', element, 'phone', false)}</td>`;

          else if('creator_page_contact_mail' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'mail', false)}</td>`;

          else if('creator_page_bio' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'bio', false)}</td>`;

          else if('creator_page_filmography' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'filmography', false)}</td>`;

          else if('creator_page_year' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'bYear', false)}</td>`;

          else if('creator_page_b_place' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'bPlace', false)}</td>`;

          else if('creator_page_site' === elementInput.attributes.name.nodeValue)
            rowHTML += `<td>${stringAddValueOnKey('', element, 'site', false)}</td>`;

          else if('order_number' === elementInput.attributes.name.nodeValue) {
              // rowHTML += `<td></td>`;
            // countRow += 1;
            rowHTML += `<td>${countRow}</td>`;
          } else
            rowHTML += `<td></td>`;
        }
      });

    rowHTML += '</tr>';

  // body...
  });

  rowHTML += '</table>';
  // console.log(rowHTML);
  tableHTMLCreator = tableHTMLCreator +  rowHTML;

  exportBody.innerHTML += tableHTMLCreator;
}

function removeSymbolInStartString(str , removeSymbol){

  if(str && str.length > 1) 
    if (removeSymbol === str.charAt(0))
      str = str.substring(1);
  
  return str;
}
function buildBody(dataServ) {
  // console.log(dataServ);
  let countRow = 0;
  if(dataServ) {
    dataServ.forEach((element) => {
        let rowHTML = '<tr>';

        if(element.hasOwnProperty('creatorPage') && element['creatorPage']){
          element['creatorPage'].forEach((elementCreator) => {
            allCreators.push(elementCreator);
          });
        };

        exFilmsCardAllInputFilms.forEach((elementInput) => {
          if(elementInput.attributes.name.nodeValue && elementInput.attributes.name.nodeValue.length  > 1 && elementInput.checked && element)
          {
           
            if('crew' === elementInput.attributes.name.nodeValue){
                let crewStr =  '';
                let objectToParse = element['crew'];
                if(element.hasOwnProperty('crew') && element['crew'])
                  JSON.parse(element['crew']).forEach((element) => {
                    crewStr += `${searchPost(element.id)}: <b name="crew">${element.name}</b><br>`;
                });
                rowHTML += `<td>${crewStr}</td>`;


            } else if('edu_year' ===  elementInput.attributes.name.nodeValue){

              let someValue = parseInt(element[elementInput.attributes.name.nodeValue]);
              let studioType = parseInt(element['studio_type']);
              if (studioType === 2) {
                  if (someValue)
                    rowHTML += `<td>${someValue} курс</td>`;
                  else
                    rowHTML += '<td></td>';
              } else 
               rowHTML += '<td></td>';


            } else if('edu_teacher' ===  elementInput.attributes.name.nodeValue) {

              if (element['edu_teacher'])
                rowHTML += `<td>${element['edu_teacher']}</td>`;
              else {
                let localRow = false;

                if(element['crew']) {
                  let objectToParse = element['crew'];
                  if(element.hasOwnProperty('crew') && element['crew'])
                    JSON.parse(element['crew']).forEach((element) => {
                      if (parseInt(element.id) === 47) {
                        localRow = `<td>${element.name}</td>`;
                      }
                  });

                  if(!localRow)
                    localRow = '<td>пусто</td>';
                  rowHTML += localRow;
                }
              }

            } else if('edu_type' ===  elementInput.attributes.name.nodeValue){
              let someValue = parseInt(element['edu_type']);
              let studioType = parseInt(element['studio_type']);

              if(someValue === 2)
                 rowHTML += '<td>дипломная</td>';
              else if(someValue === 1)
                 rowHTML += '<td>курсовая</td>';
              else if(someValue === 0 && studioType === 2)
                 rowHTML += '<td>учебная</td>';
               else
                 rowHTML += '<td></td>';

            } else if (element.hasOwnProperty(elementInput.attributes.name.nodeValue) && 
                      ('studio_contact_info_email' === elementInput.attributes.name.nodeValue 
                    || 'studio_contact_info_phone' === elementInput.attributes.name.nodeValue
                    || 'creator_contact_info_email' === elementInput.attributes.name.nodeValue
                    || 'creator_contact_info_phone' === elementInput.attributes.name.nodeValue
                    || 'creator' === elementInput.attributes.name.nodeValue 
                    || 'creator_ENG' === elementInput.attributes.name.nodeValue 
                    )) {
              let someValue = element[elementInput.attributes.name.nodeValue];
              someValue = removeSymbolInStartString(someValue,' ');
              someValue = removeSymbolInStartString(someValue,',');
              someValue = removeSymbolInStartString(someValue,' ');
              rowHTML += `<td>${someValue}</td>`;

            } else if(element.hasOwnProperty(elementInput.attributes.name.nodeValue)) {
              let someValue = element[elementInput.attributes.name.nodeValue];
              // console.log(someValue);
              if (someValue)
                rowHTML += `<td>${someValue}</td>`;
              else
                rowHTML += `<td>-</td>`;
              // else
            } else if('time_h_m_sec' === elementInput.attributes.name.nodeValue) {
              let longSec = parseInt(element['time_sec'], 10);
              let hours = Math.floor(longSec/(60*60));
              longSec -= hours * 60*60;
              let minutes = Math.floor((longSec%(60*60))/60 );
              let sec = longSec % 60;

              if(minutes < 10)
                minutes = `0${minutes}`;
              if(sec < 10)
                sec = `0${sec}`;

              rowHTML += `<td>${hours}:${minutes}:${sec}</td>`;
            }else if('order_number' === elementInput.attributes.name.nodeValue) {
              countRow += 1;
              rowHTML += `<td>${countRow}</td>`;
            } else if('rentCert' ===  elementInput.attributes.name.nodeValue){
              let rentStatus = '';
              let rentStatusINT = 0 ;
              if(element.hasOwnProperty('rentalCertStatus')){
                rentStatusINT = parseInt(element['rentalCertStatus'], 10);
                if(rentStatusINT === 2)
                  rentStatus = `${element['rentCertNumber']} (${element['rentCertDate']})`;
                else if(rentStatusINT === 1)
                  rentStatus = 'в процессе';
                else 
                  rentStatus = 'нет и не будет';
              };
              rowHTML += `<td>${rentStatus}</td>`;



            } else if('serial_title' ===  elementInput.attributes.name.nodeValue){
              let nameSerialOrFilm = '';


              nameSerialOrFilm = stringAddValueOnKey(nameSerialOrFilm, element, 'serial', true);
              if(nameSerialOrFilm.length > 1)
                nameSerialOrFilm = `${nameSerialOrFilm} : `;
              nameSerialOrFilm = stringAddValueOnKey(nameSerialOrFilm, element, 'title', false);

              rowHTML += `<td>${nameSerialOrFilm}</td>`;
            } else if('serial_title_ENG' ===  elementInput.attributes.name.nodeValue){
              let nameSerialOrFilm = '';

              nameSerialOrFilm = stringAddValueOnKey(nameSerialOrFilm, element, 'serial_ENG', true);
              if(nameSerialOrFilm.length > 1)
                nameSerialOrFilm = `${nameSerialOrFilm} : `;
              nameSerialOrFilm = stringAddValueOnKey(nameSerialOrFilm, element, 'title_ENG', false);

              rowHTML += `<td>${nameSerialOrFilm}</td>`;
            
            } else if('typeFilm' ===  elementInput.attributes.name.nodeValue){
              rowHTML += `<td>${element['typeFilmCompetition'] ? tools.getNameTypePrograms(element['typeFilmCompetition']) : ( element['typeFilmCompetition'] === 0 ? tools.getNameTypePrograms(0) : ' - - - ') }</td>`;
           
           } else if(elementInput.attributes.name.nodeValue.includes('agreementN')){

            let agreementID = parseInt(elementInput.attributes.name.nodeValue.substring(10));
            let bilo = false;
              if (element['jsonAgreements']) {
                 JSON.parse(element['jsonAgreements']).forEach((elementParse) => {
                  if(agreementID === parseInt(elementParse, 10))
                      bilo = true;
                    // crewStr += `${searchPost(element.id)}: <b name="crew">${element.name}</b><br>`;
                });
              }
            
            if (bilo)
              rowHTML += `<td>Согласие получено</td>`;
            else
              rowHTML += `<td>-</td>`;



            }else
              rowHTML += `<td>-</td>`;
            //найти элемент в массиве и вставитьв html
          }
        });
      rowHTML += '</tr>';
      // console.log(rowHTML);
      tableHTML = tableHTML +  rowHTML;
    }); 

      tableHTML = tableHTML + '</table>';

      exportBody.innerHTML = tableHTML;
  } else
    alert('Таблица пуста');
}

function translateField(nameField){
  if(nameField === 'order_number')
    return '№';
  else if(nameField === 'order_number_request')
    return '№ заявки';
  else if(nameField === 'serial')
    return 'Сериал';
  else if(nameField === 'title')
    return 'Навзание';
  else if(nameField === 'serial_title')
    return 'Сериал + название';
  else if(nameField === 'serial_ENG')
    return 'Serial';
  else if(nameField === 'title_ENG')
    return 'Title';
  else if(nameField === 'serial_title_ENG')
    return 'Serial + title';
  else if(nameField === 'about_ENG')
    return 'About';
  else if(nameField === 'about')
    return 'Аннотация';
  else if(nameField === 'crew')
    return 'Над фильмом работали';
  else if(nameField === 'time_h_m_sec')
    return 'Продолжительность';
  else if(nameField === 'time_sec')
    return 'Продолжительность';
  else if(nameField === 'year')
    return 'Год';
  else if(nameField === 'year_limit')
    return 'Возрастное ограничение';
  else if(nameField === 'techs')
    return 'Техники';
  else if(nameField === 'country')
    return 'Страна';
  else if(nameField === 'creator')
    return 'Режиссер';
  else if(nameField === 'creator_ENG')
    return 'Director';
  else if(nameField === 'creator_contact_info')
    return 'Котанкты режиссера';
  else if(nameField === 'creator_contact_info_email')
    return 'E-mail режиссера';
  else if(nameField === 'creator_contact_info_phone')
    return 'Номер телефона режиссера';

  else if(nameField === 'studio')
    return 'Студия-производитель';
  else if(nameField === 'studio_contact_info')
    return 'Студия-производитель';
  else if(nameField === 'studio_contact_info_email')
    return 'E-mail cтудии-производителя';
  else if(nameField === 'studio_contact_info_phone')
    return 'Номер нелефона студии-производителя';
  else if(nameField === 'studio_adress')
    return 'Адрес студии-производителя';
  else if(nameField === 'applicant')
    return 'Заявитель';
  else if(nameField === 'applicant_contact_info')
    return 'Контакты заявителя';
  else if(nameField === 'applicant_contact_info_email')
    return 'E-mail заявителя';
  else if(nameField === 'applicant_contact_info_phone')
    return 'Номер телефона заявителя';

  else if(nameField === 'applicant_comment')
    return 'Комментарий';
  else if(nameField === 'date_request')
    return 'Дата';
  else if(nameField === 'link')
    return 'Ссылка';
  else if(nameField === 'password')
    return 'Пароль';
  else if(nameField === 'rentCert')
    return 'Прокатное удостоверение';
  else if(nameField === 'copyright_holder')
    return 'Правообладатель';
  else if(nameField === 'copyright_holder_contacnt_info')
    return 'Контакты правообладателя';
  else if(nameField === 'copyright_holder_contacnt_info_email')
    return 'E-mail правообладателя';
  else if(nameField === 'copyright_holder_contacnt_info_phone')
    return 'Номер телефона правообладателя';
  else if(nameField === 'typeFilm')
    return 'Тип работы';

  else if(nameField === 'copyright_holder_adress')
    return 'Адрес правообладателя';
  else if(nameField === 'a')
    return 'Прокатное удостоверение';
  // else if(nameField === 'nomination')
  //   return 'Номинация';
  else if(nameField === 'nomination')
    return 'Категория';
  else if(nameField === 'date_request')
    return 'Дата'
  else if(nameField === 'creator_page_fio')
    return 'ФИО'
  else if(nameField === 'creator_page_fio_ENG')
    return 'Full name'
  else if(nameField === 'creator_page_contact_phone')
    return 'Телефон'
  else if(nameField === 'creator_page_contact_mail')
    return 'Почта'
  else if(nameField === 'creator_page_bio')
    return 'Биография'
  else if(nameField === 'creator_page_filmography')
    return 'Фильмография'
  else if(nameField === 'creator_page_year')
    return 'Год рождения'
  else if(nameField === 'creator_page_b_place')
    return 'Место рождения'
  else if(nameField === 'studio_teacher')
    return 'Руководитель'
  else if(nameField === 'edu_type')
    return 'Тип работы'
  else if(nameField === 'edu_year')
    return 'Курс'
  else if(nameField === 'edu_teacher')
    return 'Преподаватель'

  else if(nameField.includes('agreementN')) {
    let returnValue  = '';
    let agreementID = parseInt(nameField.substring(10));
    allAgreemetnLists.forEach((aElement) => {
      if (parseInt(aElement.id) === agreementID) {

        returnValue = aElement.name.length > 20 ? (aElement.name.substring(0,20)+ ' ...') : aElement.name;
 
      }
    });
    return String(returnValue);
  }
  else
    return '-';

}
function makeExport(argument) {

   let wb = TableToExcel.initWorkBook();

    wb = TableToExcel.tableToSheet(wb, document.getElementById("tab1"), {
              name: `fest_${auth.currentFestival}.xlsx`,
              sheet: {
              name: "Заявленные работы"
              }});

    wb = TableToExcel.tableToSheet(wb, document.getElementById("tab2"), {
              name: `fest_${auth.currentFestival}.xlsx`,
              sheet: {
              name: "Режиссеры"
              }});

    TableToExcel.save(wb, `fest_${auth.currentFestival}.xlsx`);

}

  function reloadInitSettings() {

    xhr.request = {
        metod: 'GET',
        url: `festival/${auth.currentFestival}/agreements/`,
        data: '',
        callbackSuccess: (answer) => {
          let htmlBodyAgreements = `<b>Добровольные согласия:</b>`;
          if(answer.data){
            allAgreemetnLists = answer.data;
            answer.data.forEach((aElement) => {
              if(aElement.optional == 1)
                htmlBodyAgreements += `<div><input type="checkbox" name="agreementN${aElement.id}" checked>${aElement.name.length > 100 ? (aElement.name.substring(0,100)+ ' ...') : aElement.name}</div>`;
            });
          };
          exFilmsCard.querySelector('div[name=optionailListAgreements]').innerHTML = htmlBodyAgreements;
          exFilmsCardAllInputFilms = exFilmsCard.querySelector('div[name=page_films]').querySelectorAll('input');
        }
      };
  }

export default {

  start() {

    menuBt.addEventListener('click', reloadInitSettings);
  },

  export(){
    makeExport();
  },


  stop() {
    pointsMarkup.cleanContainer();
  }
};
